import React, { VFC } from 'react';
import T from 'i18n-react';
import { useTheme } from '@material-ui/core/styles';
import StarIcon from '@material-ui/icons/StarBorder';
import Styled from '../Styled';
import IconWithWord from './MuiIconWithWord';

// js codes
import { FAVORITE_PLANS } from '../../../routing';

const { IconWrapper, IconLink } = Styled;

interface Props {}
const FavoritePlansIconLink: VFC<Props> = (props: Props) => {
  const theme = useTheme();
  return (
    <IconWrapper theme={theme}>
      <IconLink href={FAVORITE_PLANS}>
        <IconWithWord
          Icon={StarIcon}
          word={T.translate('header.menu.favoritePlans')}
        />
      </IconLink>
    </IconWrapper>
  );
};

export default FavoritePlansIconLink;
